import type { BotDifficulty } from '../utils/bot/types';

export type VirtualRivalId = Exclude<BotDifficulty, 'zenda'>;

export interface VirtualRival {
  id: VirtualRivalId;
  displayName: string;
  label: 'Rival virtual';
  levelLabel: string;
  styleLabel: string;
  description: string;
  engineProfile: VirtualRivalId;
  avatarColor: string;
  icon: 'smile' | 'bot' | 'zap';
}

export const ZENDA_COACH_ID = 'zenda' as const;

export const ZENDA_COACH = {
  id: ZENDA_COACH_ID,
  displayName: 'Zenda',
  label: 'Coach',
  description: 'Zenda busca la mejor jugada posible dentro del vocabulario y las reglas de esta partida.',
  avatarColor: 'bg-emerald-600',
  icon: 'lightbulb' as const,
};

export const VIRTUAL_RIVALS: VirtualRival[] = [
  {
    id: 'axel',
    displayName: 'Axel',
    label: 'Rival virtual',
    levelLabel: 'Facil',
    styleLabel: 'Tranquilo',
    description: 'Ideal para empezar. Juega palabras sencillas y partidas relajadas.',
    engineProfile: 'axel',
    avatarColor: 'bg-green-500',
    icon: 'smile',
  },
  {
    id: 'nilo',
    displayName: 'Nilo',
    label: 'Rival virtual',
    levelLabel: 'Medio',
    styleLabel: 'Equilibrado',
    description: 'Un rival equilibrado para practicar sin presion.',
    engineProfile: 'nilo',
    avatarColor: 'bg-blue-500',
    icon: 'bot',
  },
  {
    id: 'orion',
    displayName: 'Orion',
    label: 'Rival virtual',
    levelLabel: 'Experto',
    styleLabel: 'Estrategico',
    description: 'Un rival exigente, mas metodico y estrategico.',
    engineProfile: 'orion',
    avatarColor: 'bg-purple-600',
    icon: 'zap',
  },
];

const LEGACY_VIRTUAL_RIVAL_ALIASES: Record<string, VirtualRivalId> = {
  axel: 'axel',
  nilo: 'nilo',
  orion: 'orion',
  zenda: 'orion',
  vega: 'orion',
  vera: 'orion',
};

export const isVirtualRivalPlayerId = (playerId?: string | null) => playerId === 'ROBOT';

export const isVirtualRivalOpponentType = (opponentType?: string | null) => (
  opponentType === 'bot' || opponentType === 'robot' || opponentType === 'virtual'
);

export const resolveVirtualRivalId = (id?: string | null): VirtualRivalId => {
  if (!id) return 'nilo';
  return LEGACY_VIRTUAL_RIVAL_ALIASES[id.toLowerCase()] || 'nilo';
};

export const getVirtualRival = (id?: string | null): VirtualRival => {
  const rivalId = resolveVirtualRivalId(id);
  return VIRTUAL_RIVALS.find((rival) => rival.id === rivalId) || VIRTUAL_RIVALS[1];
};

export const getVirtualRivalName = (id?: string | null) => getVirtualRival(id).displayName;

export const getVirtualRivalEngineProfile = (id?: string | null): VirtualRivalId => getVirtualRival(id).engineProfile;

export const getPublicCoachId = (coachMode?: boolean | null) => (
  coachMode ? ZENDA_COACH_ID : undefined
);
